window.HELP_IMPROVE_VIDEOJS = false;
videojs.options.vhs.overrideNative = true;
videojs.options.html5.nativeAudioTracks = false;
videojs.options.html5.nativeVideoTracks = false;

let isiOS = navigator.userAgent.match(/(iPad|iPhone|iPod)/) !== null;

const Component = videojs.getComponent('Component');
// 全画面ボタンの横位置調整の為、ダミーの非表示ボタンを追加している
const placeholderButton = videojs.extend(Component, {
  constructor: function (player, options) {
    Component.call(this, player, options);
  },
  createEl: function () {
    var divObj = videojs.dom.createEl('div', {
      className: 'vjs-placeholder-button vjs-control disabled',
      innerHTML: ''
    })
    return divObj
  },
})
videojs.registerComponent('placeholderButton', placeholderButton);

/**
 * 「シークバー」、「スキップ」、「 倍 速 」の非 表 示・表示切り替える
 * @param player
 * @param hiddenSeekbarFlag　ボタンが非表示フラグ
 */
function toggleButtonsInSeekbar(player, hiddenSeekbarFlag) {
  // 倍速設定
  $('.vjs-playback-rate').hide();
  // シークバー
  player.controlBar.progressControl.hide();
  player.controlBar.placeholderButton.hide();
  if (hiddenSeekbarFlag) {
    player.controlBar.progressControl.hide();
    player.controlBar.placeholderButton.show();
    $('.vjs-playback-rate').hide();
  } else {
    player.controlBar.progressControl.show();
    player.controlBar.placeholderButton.hide();
    $('.vjs-playback-rate').show();
    player.seekButtons({
      forward: 30,
      back: 10
    });
  }
}

// Set current time seek bar
function convert(value) {
  const zeroPad = (num, places) => String(num).padStart(places, '0')
  return Math.floor(value / 60) + ":" + (value % 60 ? zeroPad(value % 60, 2) : '00')
}

function offsetPointerRange(percentage) {
  return 8 - percentage * 0.15;
}

function setBubble(bubble, val, duration) {
  const new_val = Number((val / duration) * 100);
  let val_display = Math.trunc(val);
  bubble.html(convert(val_display));
  // Sorta magic numbers based on size of the native UI thumb
  bubble.css('left', `calc(${new_val}% + (${offsetPointerRange(new_val)}px))`);
}

function sliderTooltip(e, duration) {
  let input_range = e.target;
  let tooltip = $('.video-tooltip');
  let range_width = input_range.offsetWidth;
  let current_mouse_pos = e.offsetX - offsetPointerRange((e.offsetX / range_width) * 100);
  let current_val = Math.round(current_mouse_pos / range_width * 500);

  if (current_val < 0) current_val = 0;
  if (current_val > 500) current_val = 500;
  tooltip.html(convert(Math.trunc(current_val / 500 * duration)));
  tooltip.css('left', `${e.offsetX}px`);
}

var LibraryView = function (options, ended_func, showEnqueteFunc) {
  const video_settings = createVideoSettings(isiOS);
  var user_id = options.user_id;
  var library_id = options.library_id;
  var campaign_library_id = options.campaign_library_id;
  var start_offset = options.start_offset;
  var training_content_id = options.training_content_id;
  var section_id = options.section_id;
  var video_360_info = options.video_360_info;
  var previous_current_time = options.previous_current_time;
  var withCredentials = options.withCredentials;

  // オンデマンドセミナーかのフラグ
  var on_demand_seminar_mode = options.on_demand_seminar_mode;
  // 幕前画像
  var on_demand_seminar_before_poster = options.on_demand_seminar_before_poster;
  // 終了後画像
  var on_demand_seminar_after_poster = options.on_demand_seminar_after_poster;
  // t_campaign_apply_schedule.id
  let apply_schedule_id = options.apply_schedule_id;
  // 初回再生時シークバーを隠す
  const hiddenSeekbarFlag = options.hidden_seekbar_flag || false;

  this.library_id = library_id;
  this.campaign_library_id = campaign_library_id;
  this.user_id = user_id;
  this.training_content_id = training_content_id;
  this.savePlayLogWhenStartFlag = false;
  var timer = new easytimer.Timer();
  var library_view = this;
  var interval_speek = null;
  var init_video = false;
  let initDone = false;
  var library_view_channel = App.cable.subscriptions.create({
    channel: 'LibraryViewChannel',
    library_id: library_id,
    campaign_library_id: campaign_library_id,
    user_id: user_id,
    training_content_id: training_content_id,
    section_id: section_id
  }, {
    connected: function () {
      if (init_video) return;
      init_video = true;
      $.get("/api/get_video_url/" + library_id).done(function (res) {
        var player = videojs('my-player', video_settings, function () {
          var videojs_object = this;

          toggleButtonsInSeekbar(this, hiddenSeekbarFlag);
          this.on('error', function (e) {
            var error = this.error();
            console.log(error);
            clearInterval(interval_speek);
          });
          this.on('loadedmetadata', function (e) {
            videojs_object.updateStyleEl_();
            // set current time when it's not iOS
            if (!isiOS)
              videojs_object.currentTime(previous_current_time);
          });
          this.on('canplaythrough', function (e) {
            // set current time to previous_current_time seconds into the video while only iOS
            if (isiOS && !initDone) {
              videojs_object.currentTime(previous_current_time);
              initDone = true;
            }
          });
          this.on('play', function () {
            // --- 視聴ログ関連 ---
            if (typeof onDemandFlag !== 'undefined' && !onDemandFlag && typeof viewLog !== 'undefined') {
              viewLog.isPlayed = true
              viewLog.isPausing = false
              if (viewLog.viewLogIntervalIdList.length >= 1) viewLog.stopAllSetInterval();
              const videoEl = $("#my-player").children('video')[0];
              if (!viewLog.isAfterSeeked && !viewLog.isAfterPaused) viewLog.sendLogToServer(videoEl.currentTime)
              viewLog.sendViewLogEveryTenSecond('ondemand', {videoEl});
              viewLog.isAfterPaused = false
              viewLog.isAfterSeeked = false
            }
            // ------------------

            timer.start();
            if (videojs_object.techName_ == "Flash") {
              window.setTimeout(function () {
                videojs_object.updateStyleEl_();
              }, 1000);
            }
            if (interval_speek) clearInterval(interval_speek);
            interval_speek = window.setInterval(function () {
              try {
                library_view_channel.speak(videojs_object.currentTime(), calc_viewing_time(timer));
              } catch (e) {

              }
            }, 5000);
            //動画を再生すると、閲覧ログを保存します。
            if (!this.savePlayLogWhenStartFlag) {
              library_view_channel.savePlayLogWhenStart(library_id, campaign_library_id, user_id, training_content_id, true, this.duration(), apply_schedule_id);

              library_view_channel.mark_video_as_cleared();
              if ($('#training_cancel').length) {
                $('#training_cancel').remove();
              }

              this.savePlayLogWhenStartFlag = true;
            }
            $('.btn-play .mdi').removeClass('mdi-play').addClass('mdi-pause');
          });
          this.on('pause', function () {
            // --- 視聴ログ関連 ---
            if (typeof viewLog !== 'undefined') {
              viewLog.isPausing = true
              viewLog.isAfterPaused = true
              viewLog.stopAllSetInterval();
            }
            // ------------------

            timer.pause();
            clearInterval(interval_speek);
            $('.btn-play .mdi').removeClass('mdi-pause').addClass('mdi-play');
          });
          this.on('ended', function () {
            timer.pause();

            // --- 視聴ログ関連 ---
            if (typeof viewLog !== 'undefined') {
              viewLog.stopAllSetInterval();
            }
            // ------------------

            try {
              // 再生終わる時に、動画のdurationをチェックする。
              // nilだったら、currentTimeでupdateします
              library_view_channel.endSpeak(videojs_object.currentTime());
              library_view_channel.speak(videojs_object.currentTime(), calc_viewing_time(timer));
            } catch (e) {

            }
            if (this.isFullscreen()) this.exitFullscreen();
            ended_func();

            // 終了後画像(オンデマンドセミナー)
            if (on_demand_seminar_mode) {
              player.poster(on_demand_seminar_after_poster);
              // ポスターを表示する
              player.hasStarted(false);
            }
          });
          this.on('touchend', function (e) {
            if (e.target.nodeName === 'VIDEO') {
              if (library_view.player.paused()) {
                this.play();
              } else {
                this.pause();
              }
            }
          });
          this.on('seeked', function () {
            // --- 視聴ログ関連 ---
            if (typeof viewLog === 'undefined') return;
            if (viewLog.viewLogIntervalIdList.length >= 1) viewLog.stopAllSetInterval();
            if (!viewLog.isPlayed) return
            viewLog.isAfterSeeked = true
            if (viewLog.isPausing) return
            const videoEl = $("#my-player").children('video')[0];
            viewLog.sendViewLogEveryTenSecond('ondemand', {videoEl});
            // ------------------
          })
          this.on('seeking', function () {
            // --- 視聴ログ関連 ---
            if (typeof viewLog === 'undefined') return;
            if (!viewLog.isPlayed || viewLog.isPausing) return;
            if (viewLog.viewLogIntervalIdList.length >= 1) viewLog.stopAllSetInterval();
            // ------------------
          })
          if (isiOS) {
            // iOSではフルスクリーンボタンを非表示
            const fullscreen = player.controlBar.getChild("FullscreenToggle")
            fullscreen.hide();
            // フルスクリーンのする手段はないはずだが念の為フルスクリーンになったときに解除する
            this.on('fullscreenchange', function () {
              setTimeout(() => {
                if (player.isFullscreen()) {
                  this.exitFullscreen();
                }
              }, 500)
            })
          }
        });
        player.src({type: "application/x-mpegurl", src: res, withCredentials: withCredentials});
        player.hlsQualitySelector();
        player.offset({
          start: start_offset,
          restart_beginning: false
        });

        // 幕前画像(オンデマンドセミナー)
        if (on_demand_seminar_mode) {
          player.poster(on_demand_seminar_before_poster);
        }

        if (video_360_info && video_360_info['video_360_flag']) {
          player.mediainfo = player.mediainfo || {};
          player.mediainfo.projection = video_360_info['video_360_type'];
          player.vr({projection: 'AUTO'});
        }
        library_view.player = player;

        player.on('timeupdate', function () {
          let current_value = player.currentTime() / player.duration();

          if ($('#chapter-range').length > 0) {
            $('#chapter-range').val(current_value * 500);
            let bubble = $('.bubble');
            setBubble(bubble, player.currentTime(), player.duration());
          }
        });
        // 電子透かし初期化
        // video_settings変数はlive_view.jsとlibrary_view.jsの両方で設定されているため、
        // 両ファイルが同じページで同時に読み込まれると競合が発生します。
        // そのため、カスタムイベントを呼び出すことで、電子透かし初期化する。
        document.dispatchEvent(
          new CustomEvent('videojs_ready_for_watermark', {detail: video_settings})
        );

        $('#chapter-range').on('input', function () {
          player.currentTime($(this).val() / 500 * player.duration());
          if ($('.bubble').length > 0) {
            let bubble = $('.bubble');
            setBubble(bubble, player.currentTime(), player.duration());
          }
        });

        $('#chapter-range').on('mouseenter', function () {
          $('.video-tooltip').css('display', 'block');
        })

        $('#chapter-range').on('mouseleave', function () {
          $('.video-tooltip').css('display', 'none');
        })

        $('#chapter-range').on('mousemove', (e) => sliderTooltip(e, player.duration()))

      });
    },
    disconnected: function () {
    },
    received: function (data) {
      if (data.func_name == "show_enquete") {
        if (showEnqueteFunc != null) showEnqueteFunc(data.show_after_enquete_flag);
      }
    },
    savePlayLogWhenStart: function (library_id, campaign_library_id, user_id, training_content_id, update_library_view_log, duration, apply_schedule_id) {
      return this.perform('speak', {
        library_id: library_id,
        campaign_library_id: campaign_library_id,
        user_id: user_id,
        training_content_id: training_content_id,
        update_library_view_log: update_library_view_log,
        duration: duration,
        apply_schedule_id: apply_schedule_id
      });
    },
    speak: function (current_time, viewing_time) {
      // ActionCableでの通信
      this.perform('speak', {current_time: current_time, viewing_time: viewing_time});

      // Salesforce連携（必要に応じて）
      const payload = {
        campaign_library_id: campaign_library_id,
        user_id: user_id
      };
      fetch('/api/v1/mypage/salesforces/campaign_library_linkage', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify(payload)
      }).catch(error => console.error('Salesforce linkage error:', error));
    },
    endSpeak: function (current_time) {
      return this.perform('speak', {video_duration: current_time});
    },
    mark_video_as_cleared: function () {
      if (user_id && training_content_id && section_id) {
        if (typeof getTrainingProgress === 'function') {
          setTimeout(getTrainingProgress, 1000)
        }
      }
      return true
    }
  }); //App.cable.subscriptions.create
  this.channel = library_view_channel;
  interval_speek = null;
}

window.LibraryView = LibraryView;
